import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Box } from 'roo-ui/components';
import { ImageLoader, ImageLoaderProps } from '../ImageLoader';

const PRELOAD_DISTANCE = '200px';

export const ImageLazyLoader = ({
  width,
  height,
  cover = true,
  ...rest
}: ImageLoaderProps) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: `${PRELOAD_DISTANCE} 0px ${PRELOAD_DISTANCE} 0px`,
  });

  if (inView)
    return (
      <ImageLoader cover={cover} width={width} height={height} {...rest} />
    );

  return <Box ref={ref} width={width} height={height} />;
};
